import React, { useEffect, useState } from 'react';
import { useGetDta } from '../../hooks/useGetDta';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import LoadinSpin from '../ui/LoadinSpin';
import { Button, Card, Form, Spinner } from 'react-bootstrap';

const ProxySettings = () => {
    const [proxy, setProxy] = useState('');
    const { loading, data } = useGetDta('main/general/proxy');
    const { setResp } = useContextInfo();
    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    useEffect(() => {
        if (data.items) {
            const datos = JSON.parse(data.items);
            if (datos.proxy) setProxy(datos.proxy);
        }
    }, [data]);

    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(`plus/general`, { info: 'proxy', id: data.id, items: { proxy } }, 'PUT');
            setResp(res);
        }
        setLoad(false);
    };
    if (loading) return <LoadinSpin />;
    return (
        <Card>
            <Card.Body>
                <Form noValidate validated={validated} onSubmit={onSubmit}>
                    <Form.Group className="mb-3" controlId="validationCusto">
                        <Form.Label>Url web proxy</Form.Label>
                        <Form.Control
                            type="text"
                            value={proxy}
                            required
                            placeholder="runtimewifi.mx/"
                            onChange={(e) => setProxy(e.target.value)}
                        />
                        <Form.Control.Feedback>Válido</Form.Control.Feedback>
                    </Form.Group>{' '}
                    {load ? (
                        <Button color="primary" disabled>
                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                            Guardando...
                        </Button>
                    ) : (
                        <Button type="submit">Guardar</Button>
                    )}
                </Form>
            </Card.Body>
        </Card>
    );
};

export default ProxySettings;
